import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "caret", "caretIcon"]
  static values = { expanded: Boolean }

  connect() {
    this.updateCaret()
  }

  toggle(event) {
    if (event.target.closest("[data-nav-options]")) return
    this.expandedValue = !this.expandedValue
    this.menuTarget.style.display = this.expandedValue ? "" : "none"
    this.updateCaret()
  }

  updateCaret() {
    if (!this.hasCaretIconTarget) return
    const classes = this.expandedValue
      ? "fa-solid fa-caret-down text-[14px]"
      : "fa-solid fa-caret-right text-[14px]"
    this.caretIconTarget.setAttribute("class", classes)
  }
}
